import axios from "axios";

const DOMAIN_PATTERN = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)*[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;

const buildUrl = (domain, path) => {
  const normalizedDomain = typeof domain === "string" ? domain.trim() : "";

  if (!normalizedDomain || !DOMAIN_PATTERN.test(normalizedDomain)) {
    throw new Error("Invalid PBX domain");
  }

  return `https://${normalizedDomain}/v1/${path}`;
};

export const listBlockedIps = async (domain) => {
  try {
    const {data} = await axios.get(buildUrl(domain, "list"));

    if (!Array.isArray(data?.blockedIps)
      || data.blockedIps.some((blockedIp) => typeof blockedIp !== "string")) {
      throw new Error("Invalid blocked IPs response");
    }

    return [...new Set(data.blockedIps)];
  } catch (error) {
    throw error;
  }
};

export const banIp = async (domain, ip) => {
  try {
    const {data} = await axios.post(buildUrl(domain, "ban"), {ip});
    return data;
  } catch (error) {
    throw error;
  }
};

export const unbanIp = async (domain, ip) => {
  try {
    const {data} = await axios.post(buildUrl(domain, "unban"), {ip});
    return data;
  } catch (error) {
    throw error;
  }
};
